<template>
    <Snackbar :timeout="timeout" v-bind="context" @close="close" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { Snackbar } from '../../../components/Snackbar';
    import { useSnackbarStore } from '../store';

    @Component({
        components: { Snackbar },
    })
    export default class AppSnackbar extends Vue {
        @Prop({ type: Number, default: 4000 })
        private timeout!: number;

        private get context() {
            return useSnackbarStore().$state;
        }

        private close() {
            useSnackbarStore().displaySnackbar(null);
        }
    }
</script>
